import './AppUserCellEditor.scss';
import { AppUserSelect } from '../app-form';
import { EditBox } from '@ui/EditBox';
import { getClosestTableBody } from '@lib/popups';
import React, { useCallback, useRef, useState } from 'react';
import { useAsyncProcessing, useCurrentUser, useUpdateDataSecurityApp } from '@hooks';
export const AppUserCellEditor = ({ applicationId, user }) => {
    const inputRef = useRef(null);
    const { isReadOnly } = useCurrentUser();
    const [newUser, setNewUser] = useState(user);
    const { request, reset } = useUpdateDataSecurityApp();
    const process = useAsyncProcessing({
        resetAction: reset,
        stateSelector: useUpdateDataSecurityApp.selectors.state
    });
    const save = useCallback((value) => {
        process.watchNextCall();
        request({
            applicationId,
            rawSalesforceId: value !== null && value !== void 0 ? value : null
        });
    }, [applicationId, process, request]);
    const handleOnChange = useCallback((value) => {
        if (newUser !== value) {
            setNewUser(value !== null && value !== void 0 ? value : '');
            save(value);
        }
    }, [newUser, save]);
    return (React.createElement(EditBox, { className: 'app-user-cell-editor', isReadOnly: isReadOnly, isSpreadsheet: true, selectionRef: inputRef, state: process.state },
        React.createElement(AppUserSelect, { allowClear: true, disableUsed: true, getPopupContainer: getClosestTableBody, key: user, onChange: handleOnChange, popupMatchSelectWidth: false, ref: inputRef, value: newUser })));
};
